import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["nameInput", "emailInput"]
  static values = { users: Object }

  connect() {
    this.handleInputChange = this.onInputChange.bind(this)
    window.addEventListener("input:change", this.handleInputChange)
    this.applyPrefill()
  }

  disconnect() {
    window.removeEventListener("input:change", this.handleInputChange)
  }

  onInputChange() {
    this.applyPrefill()
  }

  applyPrefill() {
    const userId = this.selectedUserId()
    if (!userId) return

    const user = this.usersValue[userId]
    if (!user) return

    if (this.hasNameInputTarget) {
      this.nameInputTarget.value = user.name || ''
    }

    if (this.hasEmailInputTarget) {
      this.emailInputTarget.value = user.email || ''
    }
  }

  selectedUserId() {
    const input = this.element.querySelector("input[name='lead[user_id]']")
    return input?.value?.toString()?.trim()
  }
}
